import { Table } from '../../Table';
import { Errors } from '../style';
import useTable from '../../../hooks/useTable';
import { TableComponentProps, ErrorItem } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  reporting_member_state: {
    name: 'Reporting Member state',
    order: 1,
    disabled: true
  },
  version: {
    name: 'Report Version',
    order: 2,
    disabled: true
  },
  creation_date_time: {
    name: 'Creation date and time',
    order: 3,
    disabled: true
  }
};

export const BasicTableAIF001 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.HEADER_FILE_AIFM,
    onChangeFund,
    schema: schema.HEADER_FILE_AIFM,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.HEADER_FILE_AIFM?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'HEADER_FILE_AIFM',
    columnLables
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.HEADER_FILE_AIFM?.field_names?.length === 0;

  const errors: ErrorItem[] | undefined = funds[currentDataKey]?.fund_data?.HEADER_FILE_AIFM?.find(
    item => item?.errors?.general
  )?.errors?.general;

  return (
    <>
      <Errors id="reporttables-basic-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-basic-aif001-required-error">This section must be completed</li>
        )}
        {errors?.map((item: ErrorItem) => (
          <li key={item.msg} id={`reporttables-basic-aif001-error-${idCreator(item.msg)}`}>
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="reporttables-basic-aif001-table"
        handleChanges={onChange}
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        columns={columns}
        rows={rows}
      />
    </>
  );
};
